import { useState, useEffect } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Alert,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/gymPlaceholder.svg";
import { get, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { Avatar, Tab } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import search from "../../../assets/images/Search.png";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Placeholder from "../../../assets/images/Placeholder.gif";
const Gyms = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [gymsData, setGymsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 6;

  const toggleDropdown = (gymId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [gymId]: !prevState[gymId],
    }));
  };

  const fetchGyms = async (page) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.gym}/admin?limit=${itemsPerPage}&page=${page}`
      );
      setGymsData(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
    } catch (err) {
      console.error(err);
      setError("Failed to load gyms. Please try again later.");
      setGymsData([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGyms(currentPage);
  }, [currentPage]);

  const navigate = useNavigate();
  const handleSelectChange = async (action, gymId) => {
    switch (action) {
      case "add":
        navigate(`/add-passes?gymId=${gymId}`);
        break;
      case "passList":
        navigate("/list-passes");
        break;
      case "modify":
        navigate(`/edit-gyms/${gymId}`, { state: { gymId: gymId } });
        break;
      case "delete":
        try {
          await del(`${endpoints.gym}/${gymId}`);
          setGymsData((prevData) =>
            prevData.filter((gym) => gym._id !== gymId)
          );
          toast.success("Gym Deleted Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          fetchGyms(currentPage);
        } catch (error) {
          console.error("Error Deleting Gym:", error);
          alert("Failed to delete the gym.");
        }
        break;
      default:
        break;
    }
  };

  return (
    <Card className="rounded-4 mb-2">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="ff-sora font-size-16 fw-normal primary-black">
            Gyms
          </span>
          <Link
            to="/list-gyms"
            className="ff-sora font-size-16 fw-bold secondary-black"
          >
            View All
          </Link>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div
              className="spinner-border"
              style={{
                width: "3rem",
                height: "3rem",
                color: "#3BABA6",
              }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <Alert
            color="danger"
            className="text-center ff-sora font-size-14 secondary-black fw-normal"
          >
            {error}
          </Alert>
        ) : (
          <>
            <div
              className="table-responsive hide-scrollbar"
              style={{
                height: gymsData?.length > 0 ? "400px" : "auto",
              }}
            >
              <Table
                hover
                className="table-borderless table-centered table-nowrap"
              >
                <thead>
                  <tr
                    className="ff-sora font-size-14 fw-bold primary-black"
                    style={{ lineHeight: "16.8px" }}
                  >
                    <th>Id</th>
                    <th>Gym</th>
                    <th>Location</th>
                    <th>Registered On</th>
                    <th>Visited By</th>
                    <th>Loved By</th>
                    <th>Saved By</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {gymsData?.length > 0 ? (
                    gymsData.slice(0, itemsPerPage).map((gym, index) => (
                      <tr
                        key={gym._id}
                        className="ff-sora font-size-14 secondary-black"
                        style={{ lineHeight: "16.8px", fontWeight: "400" }}
                      >
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                gym.files && gym.files.length > 0
                                  ? `${process.env.REACT_APP_IMG_URL}${
                                      gym.files.find(
                                        (val) => val.type === "image"
                                      )?.data || avatar
                                    }`
                                  : avatar
                              }
                              alt={`${gym.name} logo`}
                              className="object-fit-contain rounded-3 me-2"
                              width="32px"
                              height="32px"
                            />
                            <div>
                              <h6
                                className="ff-sora font-size-14 secondary-black"
                                style={{
                                  lineHeight: "16.8px",
                                  fontWeight: "400",
                                }}
                              >
                                {gym.name}
                              </h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          {gym.address ||
                            gym.location?.formatted_address ||
                            "N/A"}
                        </td>
                        <td>
                          {gym.createdAt
                            ? new Date(gym.createdAt.$date).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td>{gym.visitBy || "0"} People</td>
                        <td>{gym.lovedBy || "0"} People</td>
                        <td>{gym.savedBy || "0"} People</td>
                        <td>
                          <Dropdown
                            isOpen={dropdownOpen[gym._id]}
                            toggle={() => toggleDropdown(gym._id)}
                          >
                            <DropdownToggle
                              tag="button"
                              className="btn btn-link p-0"
                            >
                              <img src={moreIcon} alt="More options" />
                            </DropdownToggle>
                            <DropdownMenu end>
                              <DropdownItem
                                onClick={() =>
                                  handleSelectChange("add", gym._id)
                                }
                              >
                                Add Pass
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  handleSelectChange("passList", gym._id)
                                }
                              >
                                Pass List
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  handleSelectChange("modify", gym._id)
                                }
                              >
                                Edit Gym
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  handleSelectChange("delete", gym._id)
                                }
                              >
                                Delete Gym
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    // Empty row placeholder to keep the table structure intact
                    <tr>
                      <td colSpan="8"></td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Render placeholder outside the table */}
            {gymsData?.length === 0 && (
              <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                <img
                  src={Placeholder}
                  alt="No record placeholder"
                  className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                />
                <p className="text-center ff-sora font-size-16 fw-normal">
                  No Gym Found!
                </p>
              </div>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default Gyms;
